import firebase from 'firebase/compat/app';
import { getFirestore } from "firebase/firestore";
import { getAnalytics, logEvent } from "firebase/analytics";

const firebaseConfig = {
  apiKey: "AIzaSyAvHnoVfjyodWptIgZ-5nCMg6sVea_gSV0",
  authDomain: "hackathon-generative.firebaseapp.com",
  projectId: "hackathon-generative",
  storageBucket: "hackathon-generative.appspot.com",
  messagingSenderId: "58724537034",
  appId: "1:58724537034:web:682eede9f349a40820da33",
  measurementId: "G-FZWHH2LGYW"
};

// Initialize Firebase
const FirebaseApp = firebase.initializeApp(firebaseConfig);
const db = getFirestore(FirebaseApp);
const analytics = (name, data) => logEvent( getAnalytics(FirebaseApp), name, data);

export { FirebaseApp, db, analytics };